import LogoComponent from "components/Logos/LogoComponent";
import defaultAvatar from "assets/sampleAvatar.png";
import { useNavigate } from "react-router-dom";
import React, { useContext } from "react";
import ActionButton from "components/buttons/ActionButton";
import { CurrentUserContext } from "App";

export default function WelcomePage() {
  const navigate = useNavigate();
  const { currentUser, setCurrentUser } = useContext(CurrentUserContext);

  const nextPage = () => {
    navigate("/memories");
  };

  return (
    <div className="d-flex flex-column min-vh-100 justify-content-center align-items-center">
      <div
        className="d-flex flex-column justify-content-center align-items-center text-center gap-2 w-100"
        style={{ maxWidth: "30rem" }}
      >
        <div className="mb-4">
          <LogoComponent />
        </div>
        {/* WELCOME TEXT */}
        <div className="mb-4">
          <h1 className="heading-secondary">Welcome to Disbound</h1>
          <h2 className="heading-username">{currentUser?.username}</h2>
        </div>
        {/* AVATAR AREA */}
        <div className="mb-5" style={{ maxWidth: "20rem" }}>
          <img
            src={currentUser?.avatar && currentUser.avatar !== "sampleAvatar.png" ? currentUser.avatar : defaultAvatar}
            alt="Your Avatar"
            className="w-100 img-fluid img-thumbnail rounded-circle"
          />
        </div>
        {/* CONTINUE BUTTON */}
        <div className="w-100">
          <ActionButton
            buttonAction={nextPage}
            buttonText={"Continue"}
            className="btn fw-bold bg-main-purple"
          />
        </div>
      </div>
    </div>
  );
}
